<div class="banner"
  *transloco="let t; lang: 'en|static' read: 'accredible_adskills_com.banner'">
  <div class="content">


    <a href="http://www.adskills.com/matchmaker"
      target="_blank"
      rel="noopener noreferrer">
      <img
        [alt]="t('adskills_logo')"
        class="banner-main"
        src="/assets/themes/accredible.adskills.com/images/adskills-banner.png">

      <img
        class="banner-corner"
        src="/assets/themes/accredible.adskills.com/images/adskills-banner-corner.png">
    </a>

  </div>
</div>
